module.exports = __webpack_public_path__ + "static/compteur-9016be343c24cf784d71b195f4bf79d1.png";